import React, { useState, useEffect } from 'react';
import ProduktFormular from './ProduktFormular';
import { useNavigate } from 'react-router-dom';

export default function NeuesProduktFormular() {
  const [kategorien, setKategorien] = useState([]);
  const [einheiten, setEinheiten] = useState([]);
  const [orte, setOrte] = useState([]);
  const [loading, setLoading] = useState(true);
  const [successMsg, setSuccessMsg] = useState(null);

  const navigate = useNavigate();

  // Leere Startwerte für ein neues Produkt
  const initialValues = {
    name: '',
    menge: '',
    einheit_id: '',
    kategorie_id: '',
    lagerort_id: '',
    verfallsdatum: '',
  };

  // Stammdaten laden
  useEffect(() => {
    fetch('https://app.satoha.de/service/?modus=get-vorrat-runtimedata')
      .then(res => res.json())
      .then(data => {
        setKategorien(data.kategorien || []);
        setEinheiten(data.einheiten || []);
        setOrte(data.orte || []);
        setLoading(false);
      });
  }, []);

  // Handler für das Anlegen
  const handleAdd = async (formData) => {
    try {
      const payload = {
        modus: "add-item",
        item_name: formData.name,
        item_menge: formData.menge,
        item_einheit_id: formData.einheit_id,
        item_kategorie_id: formData.kategorie_id,
        item_ort_id: formData.lagerort_id || formData.ort_id,
        item_verfallsdatum: formData.verfallsdatum,
        item_gruppe: formData.gruppe_id || '', // falls du das Feld nutzt
      };

      const response = await fetch('https://app.satoha.de/service/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const result = await response.json();
      if (result.success) {
        // Redirect mit Erfolgsmeldung
        navigate('/', {
            state: { successMsg: `Produkt erfolgreich angelegt! Neuer Marker: #${result.marker}` }
        });
        return { success: true };
      } else {
        return { success: false, message: result.message || 'Fehler beim Anlegen.' };
      }
    } catch (err) {
      return { success: false, message: 'Netzwerkfehler beim Anlegen.' };
    }
  };

  if (loading) return <div>Lade Daten...</div>;

  return (
    <ProduktFormular
      initialValues={initialValues}
      onSubmit={handleAdd}
      mode="add"
      kategorien={kategorien}
      einheiten={einheiten}
      orte={orte}
      title="Neues Produkt anlegen"
      successMsg={successMsg}
      setSuccessMsg={setSuccessMsg}
    />
  );
}
